/* ***  VERSION 1.0.0  *** */

/**
 * Minimum browser versions
 * Chrome  49  (March 2016)
 * Firefox 45  (March 2016)
 * Opera   36  (March 2016)
 * Edge    14  (August 2016)
 * Safari  11  (September 2017)
 */

// Extensions to the JavaScript language
import './date/date.js';  // Date extensions
import './string/string.js';  // String extensions
import './cookies/cookies.js';  // Cookie extensions
import './async/async.js';  // Async modals windows

// Ecosystem class
import { Ecosystem } from './ecosystem/ecosystem.js';
window.ecosystem = new Ecosystem();
